import { z } from "zod";

export const gvProductSchema = z.object({
  id: z.number(),
  asin: z.string(),
  sku: z.string(),
  product_title: z.string(),
  product_image_url: z.string().nullable(),
  product_price: z.number(),
  variations: z.record(z.string(), z.string()).nullable(),
});
export type GVProduct = z.infer<typeof gvProductSchema>;
